"use client";

import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

/**
 * Whether the user prefers reduced motion. Returns `false` during SSR and
 * tracks live preference changes. Used to skip Silk sheet entry/exit travel
 * (direct-manipulation gestures stay enabled — they are not animation).
 */
export const usePrefersReducedMotion = (): boolean => {
  const [reduced, setReduced] = useState(typeof window !== "undefined" ? window.matchMedia(QUERY).matches : false);

  useEffect(() => {
    const media = window.matchMedia(QUERY);
    setReduced(media.matches);

    const onChange = (event: MediaQueryListEvent) => setReduced(event.matches);
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, []);

  return reduced;
};
